const firebaseConfig = {
  apiKey: "AIzaSyC98SiwPHIgu5x8WArzmFQLwV3TirMaJcw",
  authDomain: "volunter-network-ccc70.firebaseapp.com",
  databaseURL: "https://volunter-network-ccc70.firebaseio.com",
  projectId: "volunter-network-ccc70",
  storageBucket: "volunter-network-ccc70.appspot.com",
  messagingSenderId: "428574781476",
  appId: "1:428574781476:web:d6bbcaf6f19879b743e8b1"
};
export default firebaseConfig;